import { FadeIn } from '@/components/animation/reveal'
import { Marquee } from '@/components/animation/marquee'

interface MarqueeBandProps {
    words: string[]
    speed?: number
}

// Horizontal lines wrapping an infinite text marquee (home + blog).
export function MarqueeBand({ words, speed = 90 }: MarqueeBandProps) {
    return (
        <div className='section'>
            <div className='container line-container'>
                <FadeIn className='horizontal-line' />
            </div>

            <FadeIn>
                <Marquee className='infinite-carousel-container' speed={speed}>
                    <div className='infinite-text-holder'>
                        {words.map((word, index) => (
                            <h2 className='infinite-text' key={index}>
                                {word}
                            </h2>
                        ))}
                    </div>
                </Marquee>
            </FadeIn>

            <div className='container line-container'>
                <FadeIn className='horizontal-line' />
            </div>
        </div>
    )
}
